import client from "./client";

export async function fetchSettings({ signal } = {}) {
    const res = await client.get("fetch-settings", { signal });
    return res?.data?.data ?? null;
}
